const resendReportTypes = {
    results_report: 'results_report',
    report: 'report'
} as const

export { resendReportTypes }
